import defaultSchema from './default.schema';

export default {
  ...defaultSchema,
  title: 'Zaloguj się',
  type: 'object',
  properties: {
    login: {
      title: 'Nazwa użytkownika',
      type: 'string',
      fieldRequired: true
    },
    password: {
      type: 'string',
      title: 'Hasło',
      fieldRequired: true
    }
  }
};
